export default __webpack_public_path__ + "static/media/coverSoilImage.216b9a8e.png";